import { faBox, faList, faTag, faUsers } from '@fortawesome/pro-regular-svg-icons';
import { PosConfigurationItem } from 'src/models/pos-configuration/_types';

export const getIcon = (type: PosConfigurationItem['itemType']) => {
  switch (type) {
    case 'product':
      return faTag;
    case 'group':
      return faUsers;
    case 'package':
      return faBox;
    case 'plan':
      return faList;
    default:
      return faTag;
  }
};
